<ngb-rating
  (hover)="isRating = true;"
  (leave)="isRating = false;"
  (rateChange)="onChange($event)"
  [rate]="initialRating"
  [readonly]="readOnly"
  [resettable]="true">
</ngb-rating>
